import React, { useCallback, useImperativeHandle, useRef } from "react";
import ReactDOM from "react-dom";
import { AsyncTypeahead, AsyncTypeaheadProps } from "react-bootstrap-typeahead";
import { usePlacesAutocomplete } from "Hooks";
import { renderAutocompleteMenu } from "Components/Autocompletes/SearchAutocomplete";
import { PlacePredictionViewModel } from "Services/API/API";

interface SearchAddressAutocompleteProps extends Omit<
   AsyncTypeaheadProps<PlacePredictionViewModel>,
   "isLoading" | "onSearch" | "options"
> {
}

export type SearchAddressAutocompleteRef = {
   typeahead: AsyncTypeahead<PlacePredictionViewModel> | null,
   options: PlacePredictionViewModel[]
}

const SearchAddressAutocomplete = React.forwardRef<
   SearchAddressAutocompleteRef,
   SearchAddressAutocompleteProps
>((props, ref) => {
   const { isLoading, options, handleSearch } = usePlacesAutocomplete(true);
   const innerRef = useRef<AsyncTypeahead<PlacePredictionViewModel>>(null);
   useImperativeHandle(ref, () => ({
      typeahead: innerRef.current,
      options: options
   }));
   const filterBy = useCallback(() => true, []);

   return (
      <AsyncTypeahead<PlacePredictionViewModel>
         ref={innerRef}
         isLoading={isLoading}
         options={options}
         onSearch={handleSearch}
         filterBy={filterBy}
         id="search-address-autocomplete"
         labelKey={(option) => option.text ?? ""}
         minLength={3}
         renderMenu={(r, m) =>
            ReactDOM.createPortal(renderAutocompleteMenu(r, m), document.body)
         }
         {...props}
      />
   );
});

export default SearchAddressAutocomplete;
